import { NavLink } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { useLanguage } from "hooks";
import { Layout } from "components";

export default function NotFound() {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";

  return (
    <Layout>
      <div id="not_found_page" className="page_container pt-5">
        <section className="mb-3">
          <Container>
            <Row>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="d-flex justify-content-center mb-4 "
              >
                <img
                  className="not-found mw-100"
                  src={"/images/404.png"}
                  alt="Not Found"
                />
              </Col>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="d-flex justify-content-center"
              >
                <NavLink
                  to="/"
                  className="btn btn-primary btn-outline-primary-hover"
                >
                  {language.BackToHome}
                </NavLink>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </Layout>
  );
}
